/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('MailGroupController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		MailGroupFactory,
		FindAllMailGroupsByQueryParamsNonPageableFactory,
		NoPagingMailGroupFactory
	) {
		$scope.mailGroupList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('mailgroup.list.new');
		};

		$scope.goToEditState = function(mailGroup) {
			// this overview is NOT mapped, it is the main overview
			$state.go('mailgroup.list.edit', { mailGroupId: mailGroup.id });
		};

		$scope.getMailGroupList = function() {
			FindAllMailGroupsByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.mailGroupList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getMailGroupList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedMailGroupId = id;
			$('#deleteMailGroupConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			MailGroupFactory.delete(
				{ id: $scope.selectedMailGroupId },
				function() {
					$scope.loadAll();
					$('#deleteMailGroupConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteMailGroupConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
